import { OrdersApiService } from './service';
import ApiClientFactory from '../../api/client-factory';

const service = new OrdersApiService(ApiClientFactory());

export function OrdersApiServiceFactory(): typeof service {
  return service;
}
